import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";
import Wordmark from "@/components/Wordmark";
import { BriefContent } from "@/components/academy/TripBrief";
import { Status } from "@/components/academy/HubUI";

export default function SharedTripBrief() {
  const [data, setData] = useState(null), [error, setError] = useState("");
  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.slice(1)).get("token");
    const meta = document.createElement("meta"); meta.name = "referrer"; meta.content = "no-referrer"; document.head.appendChild(meta);
    if (!token) setError("This trip brief needs a valid share link from your academy.");
    else api.post("/shared/trip-brief", { token }).then(r => setData(r.data)).catch(() => setError("This brief link has expired, been revoked, or the trip is no longer shared."));
    return () => meta.remove();
  }, []);
  return <main data-testid="shared-trip-brief" className="min-h-screen bg-background text-foreground p-5 sm:p-10"><header className="flex justify-between items-center max-w-4xl mx-auto mb-10 print:hidden"><Wordmark />{data && <Button data-testid="shared-brief-print" variant="outline" onClick={() => window.print()}><Printer size={15} />Print brief</Button>}</header><div className="max-w-4xl mx-auto"><Status loading={!data && !error} error={error} />{data && <BriefContent trip={data} />}</div></main>;
}
